import { jsx as o } from "react/jsx-runtime";
const s = ({ className: r, width: t = "12", height: l = "7" }) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    width: t,
    height: l,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 7",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M10.95.843a1.034 1.034 0 0 0-1.414 0L6 4.217 2.464.843a1.034 1.034 0 0 0-1.414 0 .923.923 0 0 0 0 1.35L5.293 6.24c.39.372 1.023.372 1.414 0l4.243-4.048a.923.923 0 0 0 0-1.35Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  s as default
};
